import React from 'react';
import { View, Image } from 'react-native';
import { useTheme } from 'react-native-paper';
import { QText } from './';
import { useTranslation } from 'react-i18next';

const AutoIncludedServicesCard = ({ services, title, styles }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (!services || services.length === 0) {
    return null;
  }

  return (
    <View style={{ marginVertical: 15, width: '100%' }}>
      <QText style={{ marginBottom: 10, fontWeight: '600', fontSize: 16 }}>
        {title || 'Included'}
      </QText>
      {services
        .filter((service) => service.is_auto_included)
        .map((service, index) => (
          <View
            key={service.id}
            style={{
              backgroundColor: theme.colors.surface,
              borderRadius: 12,
              padding: 16,
              marginBottom: 12,
              borderWidth: 1,
              borderColor: theme.colors.outline + '20',
              shadowColor: theme.colors.primary,
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.1,
              shadowRadius: 4,
              elevation: 3,
            }}
          >
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              {service.image_url && (
                <View style={{ marginRight: 12 }}>
                  <Image
                    source={{ uri: service.image_url }}
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 8,
                      backgroundColor: theme.colors.surfaceVariant,
                    }}
                    resizeMode="cover"
                  />
                </View>
              )}
              <View style={{ flex: 1 }}>
                <QText
                  style={{
                    fontWeight: '600',
                    fontSize: 14,
                    color: theme.colors.onSurface,
                  }}
                >
                  {service.name}
                </QText>
                {service.description && (
                  <QText
                    style={{
                      fontSize: 12,
                      color: theme.colors.onSurfaceVariant,
                      marginTop: 2,
                      lineHeight: 16,
                    }}
                  >
                    {service.description}
                  </QText>
                )}
              </View>
              <View style={{ alignItems: 'flex-end' }}>
                <QText
                  style={{
                    fontWeight: '700',
                    fontSize: 14,
                    color: theme.colors.primary,
                  }}
                >
                  {service.price === 0 || service.price === null
                    ? t('free')
                    : `${service.currency_code || 'INR'} ${service.price}`}
                </QText>
                {service.discount_percentage > 0 && (
                  <QText
                    style={{
                      fontSize: 11,
                      color: theme.colors.onSurfaceVariant,
                      textDecorationLine: 'line-through',
                    }}
                  >
                    {service.currency_code || 'INR'}{' '}
                    {service.price + (service.savings_amount || 0)}
                  </QText>
                )}
                {service.quantity && (
                  <QText
                    style={{
                      fontSize: 11,
                      color: theme.colors.onSurfaceVariant,
                      marginTop: 2,
                      fontWeight: '500',
                    }}
                  >
                    Qty: {service.quantity}
                  </QText>
                )}
              </View>
            </View>
            {service.group && (
              <View
                style={{
                  marginTop: 8,
                  paddingTop: 8,
                  borderTopWidth: 1,
                  borderTopColor: theme.colors.outline + '20',
                }}
              >
                <QText
                  style={{
                    fontSize: 11,
                    color: theme.colors.onSurfaceVariant,
                    fontWeight: '500',
                  }}
                >
                  Category: {service.group}
                </QText>
              </View>
            )}
          </View>
        ))}
    </View>
  );
};

export default AutoIncludedServicesCard;
